/**
 * Created by swandelow on 29/09/17.
 */
export function buildWeekdayNames(locale: string): string[] {
    let weekdayNames = [];
    let d = new Date();
    d.setDate(d.getDate() - d.getDay());
    for (let i = 0; i < 7; i++) {
        weekdayNames.push(d.toLocaleDateString(locale, {weekday: 'short'}).toLocaleUpperCase().replace(/\./g, ' ').trim());
        d.setDate(d.getDate() + 1);
    }
    return weekdayNames;
}

export function formatDate(date: Date, format: string, locale: string): string {
    let tokens = [{
        str: /YYYY|YY/g,
        fn: (s) => {
            switch (s.length) {
                case 2:
                    return date.toLocaleDateString(locale, {
                        year: '2-digit'
                    });
                case 4:
                    return date.toLocaleDateString(locale, {
                        year: 'numeric'
                    });
            }
        }
    }, {
        str: /D{1,2}/g,
        fn: (s) => {
            switch (s.length) {
                case 1:
                    return date.toLocaleDateString(locale, {
                        day: 'numeric'
                    });
                case 2:
                    return date.toLocaleDateString(locale, {
                        day: '2-digit'
                    });
            }
        }
    }, {
        str: /M{1,4}/g,
        fn: (s) => {
            switch (s.length) {
                case 1:
                    return date.toLocaleDateString(locale, {
                        month: 'numeric'
                    });
                case 2:
                    return date.toLocaleDateString(locale, {
                        month: '2-digit'
                    });
                case 3:
                    return capitalize(date.toLocaleDateString(locale, {
                        month: 'short'
                    }));
                case 4:
                    return capitalize(date.toLocaleDateString(locale, {
                        month: 'long'
                    }));
            }
        }
    }];

    return tokens.reduce((o, t) => o.replace(t.str, t.fn), format);

    function capitalize(str) {
        if (!str) return '';
        return str[0].toLocaleUpperCase() + str.toLocaleLowerCase().slice(1);
    }
}


// WEBPACK FOOTER //
// ./public/upgrade/core/datepicker/calendar-view/calendar-tools.ts